import { NOTIFICATIONS } from 'context/Notifications/helpers'
import React from 'react'
import useTicketUpdateAlarm from 'apollo/mutations/Tickets/TICKET_UPDATE_ALARM'
import useRemoveNotification from 'apollo/mutations/REMOVE_NOTIFICATION'
import { StyledAlert, StyledButton, StyledText } from './styled'
import { notificationOnClick } from 'context/Notifications/helpers'
import {
  ALARM_TYPE,
  TASK_TYPE,
  BULK_CREATE_TICKETS,
  BULK_UPLOAD_CATEGORIES_TYPE,
  BENEFIT_CATEGORIES_BULK_CREATE,
  BENEFIT_GROUPS_BULK_CREATE,
  BENEFITS_BULK_CREATE,
  INTERACTIONS_BULK_CREATE,
  TICKET_DELIVERABLES_BULK_CREATE,
  TICKET_BULK_ASSIGN_TO_PERFORMER,
  TICKET_BULK_ASSIGN_TO_QUEUE,
  TICKET_BULK_ASSIGN_TO_RECIPIENT,
  TICKET_BULK_CHANGE_STATUS
} from 'context/Notifications/constants'
import { getHumanizeTimeFormat12h } from 'utils/helpers/dateHelper'
import { CloseOutlined } from '@ant-design/icons'
import { Text } from 'ui/styled'

const Notification = ({ item }) => {
  const notification = NOTIFICATIONS[item.type]
  const { onRemoveNotification } = useRemoveNotification()
  const { onUpdateTicketAlarm } = useTicketUpdateAlarm(
    'Alarm was successfully removed'
  )

  if (!notification) return <span>Failed to load notification</span>

  const description = notification.description(item)
  const date = getHumanizeTimeFormat12h(
    [ALARM_TYPE, TASK_TYPE].includes(item.type)
      ? item?.data?.notify_at
      : item?.created_at
  )

  const onClose = () => (item.type === ALARM_TYPE ? removeAlarm() : muteAlert())

  const muteAlert = async () => {
    const { ids, id } = item
    await onRemoveNotification({ ids: ids || [id] })
  }

  const removeAlarm = async () => {
    const { source_id: ticket_id } = item

    await onUpdateTicketAlarm({
      ticket_id,
      alarm: null
    })
  }

  const isClickable = ![
    BULK_CREATE_TICKETS,
    BULK_UPLOAD_CATEGORIES_TYPE,
    BENEFIT_CATEGORIES_BULK_CREATE,
    BENEFIT_GROUPS_BULK_CREATE,
    BENEFITS_BULK_CREATE,
    INTERACTIONS_BULK_CREATE,
    TICKET_DELIVERABLES_BULK_CREATE,
    TICKET_BULK_ASSIGN_TO_PERFORMER,
    TICKET_BULK_ASSIGN_TO_QUEUE,
    TICKET_BULK_ASSIGN_TO_RECIPIENT,
    TICKET_BULK_CHANGE_STATUS
  ].includes(item.type)

  return (
    <StyledAlert
      title={
        isClickable ? (
          <StyledButton
            onClick={() => notificationOnClick(item, !isClickable)}
            data-test="notificationCenterViewBtn"
          >
            {description}
          </StyledButton>
        ) : (
          <StyledText>{description}</StyledText>
        )
      }
      description={
        <Text size={12} color="gray">
          {date}
        </Text>
      }
      key={item.id}
      showIcon
      closable={{
        onClose,
        closeIcon: !!muteAlert && (
          <CloseOutlined data-test="notificationCenterCloseBtn" />
        )
      }}
      icon={notification.icon}
    />
  )
}

export default Notification
